import { render, staticRenderFns } from "./ReportSuccess.vue?vue&type=template&id=12b5c6d8&scoped=true"
import script from "./ReportSuccess.vue?vue&type=script&lang=js"
export * from "./ReportSuccess.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_appointment-report.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ReportSuccess.vue?vue&type=style&index=1&id=12b5c6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5c6d8",
  null
  
)

export default component.exports